"use strict";

Core.Document = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/document',
    idAttribute: 'uuid'
});

Core.Documents = Backbone.Collection.extend({
    model: Core.Document
});

Core.DocumentCategory = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/document/category',
    idAttribute: 'id'
});

Core.DocumentCategories = Backbone.Collection.extend({
    model: Core.DocumentCategory,
    url: function() {
        var params = {}
        if (this.groupId) params.group = this.groupId;
        if (this.entityType) params.entityType = this.entityType;
        if (this.jobId) params.job = this.jobId;
        return Core.DocumentCategory.prototype.urlRoot + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(options) {
        this.groupId = options.groupId || null;
        this.entityType = options.entityType || null;
        this.jobId = options.jobId || null;
    }
});